import React from "react";
import { SectionType } from "../types";
import { SectionContentProps } from "../types";

// Icons
import {
  PiLayoutDuotone,
  PiRocketLaunchDuotone,
  PiListDuotone,
  PiChartBarDuotone,
  PiStarDuotone,
  PiSparkle,
  PiUsersDuotone,
  PiTextT,
  PiImageDuotone,
  PiEnvelopeDuotone,
  PiInfo,
  PiCurrencyDollar,
  PiQuestion,
  PiPhoneCall,
  PiUsersThree,
  PiPlayCircle,
  PiPaperPlaneTilt,
  PiMapPin,
  PiGraduationCap,
  PiBuildings,
  PiBookOpen,
  PiCalendarBlank,
  PiNewspaper,
} from "react-icons/pi";

// Import all section components
import HeaderSection from "./header";
import HeroSection from "./hero";
import FeaturesSection from "./features";
import StatsSection from "./stats";
import TestimonialsSection from "./testimonials";
import CtaSection from "./cta";
import CompaniesSection from "./companies";
import AboutSection from "./about";
import ServicesSection from "./services";
import InfoSection from "./info";
import PricingSection from "./pricing";
import FaqSection from "./faq";
import ContactSection from "./contact";
import TeamSection from "./team";
import VideoSection from "./video";
import NewsletterSection from "./newsletter";
import LocationSection from "./location";
import { FooterController } from "./footer";
import {
  UniversityAbout,
  UniversityPrograms,
  UniversityCampus,
  UniversityResearch,
  UniversityEvents,
  UniversityBlog,
  UniversityHero,
  UniversityHeader,
  UniversityFooter,
  FAQUniversity,
} from "../university";

// Re-export all section components for preview
export {
  HeaderSection,
  HeroSection,
  FeaturesSection,
  StatsSection,
  TestimonialsSection,
  CtaSection,
  CompaniesSection,
  AboutSection,
  UniversityAbout,
  ServicesSection,
  InfoSection,
  PricingSection,
  FaqSection,
  ContactSection,
  TeamSection,
  VideoSection,
  NewsletterSection,
  LocationSection,
  FooterController,
  FooterController as FooterSection,
  UniversityPrograms,
  UniversityCampus,
  UniversityResearch,
  UniversityEvents,
  UniversityBlog,
  UniversityHero,
  UniversityHeader,
  UniversityFooter,
  FAQUniversity,
};

// Section Component Mapper
export const editableSectionComponents: Record<
  SectionType,
  React.FC<SectionContentProps>
> = {
  header: HeaderSection,
  hero: HeroSection,
  features: FeaturesSection,
  stats: StatsSection,
  testimonials: TestimonialsSection,
  cta: CtaSection,
  companies: CompaniesSection,
  footer: FooterController,
  about: AboutSection,
  "university-about": UniversityAbout,
  services: ServicesSection,
  info: InfoSection,
  pricing: PricingSection,
  faq: FaqSection,
  contact: ContactSection,
  team: TeamSection,
  video: VideoSection,
  newsletter: NewsletterSection,
  location: LocationSection,
  "university-programs": UniversityPrograms,
  "university-campus": UniversityCampus,
  "university-research": UniversityResearch,
  "university-events": UniversityEvents,
  "university-blog": UniversityBlog,
  "university-hero": UniversityHero,
  "university-header": UniversityHeader,
  "university-footer": FooterController,
  "university-faq": FAQUniversity,
};

// Section Icon Mapper
export const getSectionIcon = (type: SectionType): React.ReactNode => {
  const iconMap: Record<SectionType, React.ReactNode> = {
    header: <PiLayoutDuotone className="h-5 w-5" />,
    hero: <PiRocketLaunchDuotone className="h-5 w-5" />,
    features: <PiListDuotone className="h-5 w-5" />,
    stats: <PiChartBarDuotone className="h-5 w-5" />,
    testimonials: <PiStarDuotone className="h-5 w-5" />,
    cta: <PiSparkle className="h-5 w-5" />,
    companies: <PiUsersDuotone className="h-5 w-5" />,
    footer: <PiTextT className="h-5 w-5" />,
    about: <PiImageDuotone className="h-5 w-5" />,
    "university-about": <PiImageDuotone className="h-5 w-5" />,
    services: <PiEnvelopeDuotone className="h-5 w-5" />,
    info: <PiInfo className="h-5 w-5" />,
    pricing: <PiCurrencyDollar className="h-5 w-5" />,
    faq: <PiQuestion className="h-5 w-5" />,
    contact: <PiPhoneCall className="h-5 w-5" />,
    team: <PiUsersThree className="h-5 w-5" />,
    video: <PiPlayCircle className="h-5 w-5" />,
    newsletter: <PiPaperPlaneTilt className="h-5 w-5" />,
    location: <PiMapPin className="h-5 w-5" />,
    "university-programs": <PiGraduationCap className="h-5 w-5" />,
    "university-hero": <PiRocketLaunchDuotone className="h-5 w-5" />,
    "university-campus": <PiBuildings className="h-5 w-5" />,
    "university-research": <PiBookOpen className="h-5 w-5" />,
    "university-events": <PiCalendarBlank className="h-5 w-5" />,
    "university-blog": <PiNewspaper className="h-5 w-5" />,
    "university-header": <PiLayoutDuotone className="h-5 w-5" />,
    "university-footer": <PiTextT className="h-5 w-5" />,
    "university-faq": <PiQuestion className="h-5 w-5" />,
  };
  return iconMap[type] || <PiLayoutDuotone className="h-5 w-5" />;
};
